<!-- @format -->

<template>
	<!-- <van-field>
		<template #input> -->
	<van-switch v-model="value" :active-color="activeColor" :inactive-color="inactiveColor" />
	<!-- </template>
	</van-field> -->
</template>

<script setup lang="ts">
	interface Props {
		modelValue: boolean;
		activeColor?: string;
		inactiveColor?: string;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: false,
		activeColor: undefined,
		inactiveColor: undefined,
	});

	const emit = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});
</script>

<style scoped></style>
